/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { ApplicationType } from '../models/application-type';
@Injectable({
  providedIn: 'root',
})
class ApplicationService extends __BaseService {
  static readonly ApplicationGetAllPath = '/api/Application/GetAll';
  static readonly ApplicationGetAllActivePath = '/api/Application/GetAllActive';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param customerId undefined
   */
  ApplicationGetAllResponse(customerId?: null | number): __Observable<__StrictHttpResponse<Array<ApplicationType>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (customerId != null) __params = __params.set('customerId', customerId.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/Application/GetAll`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<ApplicationType>>;
      })
    );
  }
  /**
   * @param customerId undefined
   */
  ApplicationGetAll(customerId?: null | number): __Observable<Array<ApplicationType>> {
    return this.ApplicationGetAllResponse(customerId).pipe(
      __map(_r => _r.body as Array<ApplicationType>)
    );
  }

  /**
   * @param customerId undefined
   */
  ApplicationGetAllActiveResponse(customerId?: null | number): __Observable<__StrictHttpResponse<Array<ApplicationType>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (customerId != null) __params = __params.set('customerId', customerId.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/Application/GetAllActive`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<ApplicationType>>;
      })
    );
  }
  /**
   * @param customerId undefined
   */
  ApplicationGetAllActive(customerId?: null | number): __Observable<Array<ApplicationType>> {
    return this.ApplicationGetAllActiveResponse(customerId).pipe(
      __map(_r => _r.body as Array<ApplicationType>)
    );
  }
}

module ApplicationService {
}

export { ApplicationService }
